import { DatePipe } from '@angular/common';
import { noUndefined } from '@angular/compiler/src/util';
import { Component, EventEmitter, Input, OnInit, OnDestroy, Output, TemplateRef, ChangeDetectorRef, HostListener, ElementRef } from '@angular/core';

import { async } from '@angular/core/testing';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { RedirecFormService } from 'src/app/services/redirec-form.service';
import { UserService } from 'src/app/services/user/user.service';
import { environment } from 'src/environments/environment';

import * as alertifyjs from 'alertifyjs';
import { SocketioService } from 'src/app/services/socket/socketio.service';
import { PaymentSocketService } from 'src/app/services/socket/payment-socket.service';
import Swal from'sweetalert2';
import { AuthService } from 'src/app/services/auth/auth.service';
import { FeeService } from 'src/app/services/fee.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { saveAs } from 'file-saver';


@Component({
  selector: 'app-person-payments',
  templateUrl: './person-payments.component.html',
  styleUrls: ['./person-payments.component.css'],
  providers: [DatePipe]

})

export class PersonPaymentsComponent implements OnInit, OnDestroy {

  @Input() code_payment: any;
  @Input() code_person: any;
  @Input() code_installment: any;

  // 🎧 SUSCRIPCIÓN DE SOCKET PARA LIMPIAR DESPUÉS
  private ownerUpdatesSubscription: any;

  // 🏁 BANDERA PARA EVITAR CONFIGURAR SOCKETS MÚLTIPLES VECES
  private socketsConfigured = false;

  // 🚫 BANDERA PARA EVITAR ALERTAS DURANTE LA CARGA INICIAL
  private isInitialLoad = true;


  queryParams: any;
  person: any;

  // Modal compartido de reporte a la aseguradora (mismo flujo que la Consola de Seguros)
  insReportOpen = false;
  insReportPayment: any = null;
  section_transactions: any = [];
  transaction: any = {};
  section_transaction: any;
  loading_person = false;
  loading = false;

  buro_response: any;
  buro: any;
  buro_score: any;
  activatePsico: any;
  showActivatePsico: any;

  loading_buro = false;
  psicometrico: any;
  psicometrico_response: any;
  psicometrico_array: any = [];
  status_approved: any;
   type_approved: any;
   clientQuota:any;
   invoiceCredits: any = [];
   resp_paymentsCredits: any = [];
   installments: any = [];

   autopago: any = [{key: "BDV", name: "AUTO: BANCO DE VENEZUELA"},{key: "BA", name: "AUTO: BANCAAMIGA"}, {key: "MERCHANT", name: "AUTO: MEGASOFT"}, {key: "MC", name: "AUTO: MERCANTIL"}, {key: "AUTO-DETECT", name: "Auto detectado"}];
   banks: any;


view = 1;
invoiceSelected:any;
installMentSelected:any;
payment:any;
loadcon:any;
loadcon2:any;
subStatus:any = {};
submit_disabled_changeSubStatus: any;
list_payment_sub_status:any;

payment_base_code :any;
person_base_code :any;
invoice_base_code :any;

payments:any[] = [];

isTypeComponent: any;
productArray:any[] = [];
selectedProducts: string[] = ['CREDIT']; // Productos seleccionados
showDropdown: boolean = false; // Visibilidad del dropdown

// === SISTEMA DE ESTADOS PROFESIONAL ===
filterStates = {
  isLoadingProducts: false,    // Cargando lista de productos
  isApplyingFilter: false,     // Aplicando filtro seleccionado
  isLoadingResults: false,     // Cargando resultados de pagos
  hasError: false,             // Estado de error
  errorMessage: '',            // Mensaje de error específico
  isInitialized: false         // Si el filtro ya se inicializó
};

// Productos temporales (antes de aplicar)
tempSelectedProducts: string[] = ['CREDIT'];

// Animation states
dropdownAnimation = {
  isOpening: false,
  isClosing: false
};

// Nuevas propiedades para el filtro múltiple


  // 🔄 ASYNC PAYMENT HISTORY MODAL
  selectedAsyncPayment: any = null;

  // 🖼️ MODAL DE VISUALIZACIÓN DE ADJUNTOS
  selectedFileUrl = '';
  selectedFileType = '';
  selectedFileName = '';
  selectedFileExtension = '';

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private _user: UserService,
    private sanitizer: DomSanitizer,
    private redirecFormService: RedirecFormService,
    private datePipe: DatePipe,
    public socketService: SocketioService,
    private paymentSocketService: PaymentSocketService,
    private cdr: ChangeDetectorRef,
    public _auth : AuthService,
    public feeService: FeeService,
    private elementRef: ElementRef,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    console.log('🚀 DEBUG MODAL: ngOnInit iniciado');
    console.log('🚀 DEBUG MODAL: code_person input:', this.code_person);
    console.log('🚀 DEBUG MODAL: code_payment input:', this.code_payment);

    this.person_base_code = this.code_person;
    console.log('🚀 DEBUG MODAL: person_base_code asignado:', this.person_base_code);

    if(this.code_payment){
      this.payment_base_code = this.code_payment;
      this.isTypeComponent = true;
      console.log('🚀 DEBUG MODAL: Modo modal activado, isTypeComponent:', this.isTypeComponent);
      console.log('🚀 DEBUG MODAL: payment_base_code:', this.payment_base_code);
      this.getPerson();
      this.getBanks();
    }


    if(!this.isTypeComponent){
      console.log('🚀 DEBUG MODAL: Modo no-modal, usando activatedRoute');
      this.activatedRoute.params.subscribe(params => {
        this.queryParams = params;
        if (this.queryParams?.code) {
          this.person_base_code = this.queryParams?.code;
          this.getPerson();
          this.getBanks();
        }

      });
    }

    this.getpayment_sub_status();

    this.initializeProductFilter();

    this.loadPayments();
  }




  /**
   * Determina si un pago es elegible para anulación por "Devolución de fondos"
   * cuando figura como conciliado pero NO tiene distribución aplicada.
   * El backend reaplica las mismas precondiciones; esta es la guarda visual.
   */
  canCancelReconciledUndistributed = (item: any): boolean => {
    if (!item || !item.payment) return false;
    if (!this._auth.IsPermitid(['OWNER'])) return false;
    if (item.payment.status !== true) return false;
    if (item.payment.reconciled_payment !== true) return false;
    if (item.payment.payment_annulled === true) return false;
    const amount = Number(item.payment.amount);
    const due = Number(item.payment.totalPaymentDue);
    if (isNaN(amount) || isNaN(due)) return false;
    if (Math.abs(amount - due) > 0.009) return false;
    if (item.installMent && item.installMent.length > 0) return false;
    if (item.fees && item.fees.length > 0) return false;
    if (item.paymen_categ_concept_deduc && item.paymen_categ_concept_deduc.length > 0) return false;
    return true;
  }

  cancelReconciledUndistributed = async (code_payment: string) => {
    if (!code_payment) return;
    const result = await Swal.fire({
      title: '¿Anular pago?',
      html: `<div style="text-align: left; max-width: 100%;">
               <p style="margin: 0 0 .75rem 0;">
                 Se anulará el pago <b>${code_payment}</b>.<br>
                 El pago debe estar conciliado pero <b>sin distribución</b>.<br>
                 Esta acción no se puede revertir.
               </p>
               <label for="swal-annul-reason" style="display:block; font-size:.85rem; color:#6b7280; margin-bottom:.25rem;">
                 Concepto de anulación
               </label>
               <select id="swal-annul-reason"
                       style="display:block; width:100%; box-sizing:border-box; padding:.4rem .6rem; font-size:1rem; border:1px solid #d1d5db; border-radius:.375rem; background:#fff;">
                 <option value="Devolución de fondos">Devolución de fondos</option>
                 <option value="Gift Card">Gift Card</option>
                 <option value="Otro">Otro</option>
               </select>
               <input id="swal-annul-other" type="text" maxlength="120"
                      placeholder="Especifique el concepto"
                      style="display:none; width:100%; box-sizing:border-box; margin-top:.5rem; padding:.4rem .6rem; font-size:1rem; border:1px solid #d1d5db; border-radius:.375rem;">
             </div>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, anular',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#d97706',
      didOpen: () => {
        const sel = document.getElementById('swal-annul-reason') as HTMLSelectElement | null;
        const inp = document.getElementById('swal-annul-other') as HTMLInputElement | null;
        if (sel && inp) {
          sel.addEventListener('change', () => {
            inp.style.display = sel.value === 'Otro' ? 'block' : 'none';
            if (sel.value !== 'Otro') inp.value = '';
          });
        }
      },
      preConfirm: () => {
        const sel = document.getElementById('swal-annul-reason') as HTMLSelectElement | null;
        const inp = document.getElementById('swal-annul-other') as HTMLInputElement | null;
        const reason = sel?.value || '';
        if (!reason) {
          Swal.showValidationMessage('Seleccione un concepto de anulación');
          return false;
        }
        if (reason === 'Otro') {
          const custom = (inp?.value || '').trim();
          if (!custom) {
            Swal.showValidationMessage('Especifique el concepto cuando seleccione "Otro"');
            return false;
          }
          return custom;
        }
        return reason;
      }
    });
    if (!result.isConfirmed) return;

    this.loadcon2 = true;
    try {
      const resp: any = await this._user.cancelReconciledUndistributedPayment({
        code_payment,
        description: result.value
      });
      if (resp && resp.ok) {
        alertifyjs.success(`Pago ${code_payment} anulado (${result.value})`);
        // Refrescar la vista para que se vea el cambio de estatus.
        // getPerson() ya invoca internamente listClientPaymentsCredits() y reasigna resp_paymentsCredits.
        await this.getPerson();
      } else {
        alertifyjs.error(resp?.error?.msg || 'No se pudo anular el pago');
      }
    } catch (error: any) {
      console.error(error);
      const msg = error?.error?.error?.msg || error?.error?.message || error?.message || 'Error al anular el pago';
      alertifyjs.error(msg);
    } finally {
      this.loadcon2 = false;
    }
  }

  cancelPayment = async (payment:any) => {
    if (this._auth.hasRbac$.getValue() && !this._auth.hasAnyPermission(['finanzas.verificacion_pagos.cancel', 'pagos.pagos_registrados.cancel'])) {
      alertifyjs.error('No tienes permiso para anular pagos');
      return;
    }

    let action = 'Anular'

    Swal.fire({
      title: "¿Deseas Anular este pago?",
      text: "¡No podrás revertir esto!",
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      input: "select",
      inputOptions: {
        
        'No se encuentra en banco': 'No se encuentra en banco',
        'Pago duplicado': 'Pago duplicado',
        'Txs verificada por Merchant': 'Txs verificada por Merchant',
        'Txs verificada manualmente': 'Txs verificada manualmente',

      },
      inputPlaceholder: 'Selecciona una razón',
      showCancelButton: true,
      confirmButtonText: `Si, ${action}!`,
      showLoaderOnConfirm: true,
      preConfirm: async (reason) => {
        try {
          if (!reason) {
            return Swal.showValidationMessage(`Debe seleccionar una razón de anulación`);
          }
        } catch (error) {
          Swal.showValidationMessage(`Request failed: ${error}`);
        }
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.isConfirmed) {
        this.cancelPaymentQuestion(payment, result.value);
      }
    });

  }


  cancelPaymentQuestion = async (payment:any,msg = '') => {

    this.loadcon2 = true;
    try {

      const resp = await this._user.cancelPayment({ code_payment: payment,description:msg });


      if(this.subStatus[payment] == 'REVISION'){
        this.changeSubStatus(payment,'NA')

      }
      const resp_paymentsCredits = await this.listClientPaymentsCredits();
      this.resp_paymentsCredits = resp_paymentsCredits?.res;


      if(resp?.res){

        alertifyjs.success(`Pago anulado codigo ${payment}`);
        this.getPerson();

      }

      this.loadcon2 = false;

    } catch (error) {
      console.error(error);

    this.loadcon2 = false;
  }

    this.loading_person = false;

  }


  // Devuelve la medianoche del día actual en zona horaria Caracas.
  // Cualquier last_mora_recalculated_at anterior se considera stale.
  private getMedianocheCaracas(): Date {
    const m = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Caracas' }));
    m.setHours(0, 0, 0, 0);
    return m;
  }

  getPerson = async () => {
    this.loading_person = true;
    console.log('🔍 DEBUG: getPerson iniciado, person_base_code:', this.person_base_code);
    try {

      let resp = await this._user.getPersonbyCode({ code: this.person_base_code });
      this.person = resp.resp;
      console.log('✅ DEBUG: Persona obtenida:', this.person);

      // Si la mora del cliente no fue recalculada hoy (medianoche Caracas), forzar refresh
      // antes de mostrar el módulo de pago. Garantiza que el admin ve data fresca y que
      // cualquier pago aplicado va contra fees al rango correcto.
      const lastRecalc = this.person?.last_mora_recalculated_at
        ? new Date(this.person.last_mora_recalculated_at)
        : null;
      const isStale = !lastRecalc || lastRecalc < this.getMedianocheCaracas();
      if (isStale && this.person_base_code) {
        console.log('⏳ Mora stale, refrescando...');
        try {
          await this._user.refreshCustomerMora(this.person_base_code);
          // Re-fetch del cliente para traer el resumen actualizado
          resp = await this._user.getPersonbyCode({ code: this.person_base_code });
          this.person = resp.resp;
          console.log('✅ Mora refrescada, person actualizado');
        } catch (refreshErr) {
          console.error('⚠️ Falló refresh de mora (continuando con data actual):', refreshErr);
        }
      }

      const resp_paymentsCredits = await this.listClientPaymentsCredits();
      console.log('📊 DEBUG: Respuesta completa listClientPaymentsCredits:', resp_paymentsCredits);
      console.log('📊 DEBUG: resp_paymentsCredits.res:', resp_paymentsCredits?.res);
      
      // 🔍 DEBUG: Verificar estructura de typeProduct en los pagos
      if (resp_paymentsCredits?.res && resp_paymentsCredits.res.length > 0) {
        console.log('🔎 DEBUG TIPO PRODUCTO: Verificando primer pago:');
        const firstPayment = resp_paymentsCredits.res[0];
        console.log('  - Pago completo:', firstPayment);
        console.log('  - payment.typeProduct:', firstPayment?.payment?.typeProduct);
        console.log('  - installMent[0].payment.typeProduct:', firstPayment?.installMent?.[0]?.payment?.typeProduct);
      }


    let temp = resp_paymentsCredits?.res;
    console.log('🔧 DEBUG: temp (antes del forEach):', temp);

    temp?.forEach((element:any) => {
     // debugger
     console.log('🔄 DEBUG: Procesando elemento:', element);

     this.subStatus[element.payment.code]  = element?.payment?.payment_sub_status?.code || 'NA';

    });

    console.log('🎯 DEBUG: subStatus final:', this.subStatus);

      //payment_sub_status
      this.resp_paymentsCredits = resp_paymentsCredits?.res;
      console.log('💾 DEBUG: this.resp_paymentsCredits asignado:', this.resp_paymentsCredits);

      // Debug para verificar condiciones del template
      console.log('🔍 DEBUG TEMPLATE CONDITIONS:');
      console.log('  - loading:', this.loading);
      console.log('  - loading_person:', this.loading_person);
      console.log('  - person?.person:', this.person?.person);
      console.log('  - resp_paymentsCredits?.length:', this.resp_paymentsCredits?.length);
      console.log('  - Condición *ngIf="!loading && person?.person":', !this.loading && this.person?.person);

    } catch (error) {
      console.error(error);

    }

    this.loading_person = false;
    console.log('🏁 DEBUG: getPerson finalizado, loading_person:', this.loading_person);

    // 🚀 CONFIGURAR SOCKETS SOLO LA PRIMERA VEZ (después de obtener person)
    if (!this.socketsConfigured && this.person?.person?._id) {
      this.setupPaymentSocketListeners();

      // ⏰ MARCAR QUE LA CARGA INICIAL HA TERMINADO DESPUÉS DE UN DELAY
      setTimeout(() => {
        this.isInitialLoad = false;
        console.log('✅ [SOCKET] Carga inicial completada, activando alertas de socket');
      }, 2000); // 2 segundos de delay para asegurar que toda la carga inicial termine
    }

  }


  concilidarPago = async (payment:any) => {
    if (this._auth.hasRbac$.getValue() && !this._auth.hasAnyPermission(['finanzas.verificacion_pagos.approve', 'pagos.pagos_registrados.approve'])) {
      alertifyjs.error('No tienes permiso para aprobar pagos');
      return;
    }
    let confirm = false;
    let action = 'Conciliar';
    // verifico que el pago no este repetido, sino, emitimos alerta
    if(payment.payments_similar && payment.payments_similar.length>0) {
      Swal.fire({
        title: `Ya existe un pago con la misma referencia, cuenta destino y monto`,
        text: "¡No es posible conciliar!",
        icon: 'warning',

      }).then((result) => {
        if (result.isConfirmed) {
          confirm = false; // no queremos que si lo concilie
        }
      });
    } else {
      confirm = true;
    }

    debugger;
    if(confirm) {

      Swal.fire({
        title: `¿Deseas ${action} este pago?`,
        text: "¡No podrás revertir esto!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: `Si, ${action}!`
      }).then((result) => {
        if (result.isConfirmed) {


          this.concilidarPagoQuestion(payment?.code);

        }
      });
    }

  }



 concilidarPagoQuestion = async (payment:any) => {
  this.loadcon = true;
  try {
    const resp = await this._user.reconciledPayment({ code_payment: payment });

    if(this.subStatus[payment] == 'REVISION'){
      this.changeSubStatus(payment,'NA')

    }

    const resp_paymentsCredits = await this.listClientPaymentsCredits();
    this.resp_paymentsCredits = resp_paymentsCredits?.res;


    if(resp?.res){


      this.getPerson();


    }

    this.loadcon = false;

  } catch (error) {
    console.error(error);

  this.loadcon = false;
}

  this.loading_person = false;


}





  listClientPaymentsCredits = async (codeArray?:any) => {

    try {
         let data: any =  {
          code_person :this.person_base_code,
          arr_typeProduct: codeArray || this.selectedProducts // Enviar array de productos seleccionados
         }

         if(this.payment_base_code)
            data['payment_code'] = this.payment_base_code;

        return this._user.listClientPaymentsCreditsConsole(data);

      } catch (error) {
        console.error(error);


      }
  }




  getIdentity(item: any) {

    if (!(item?.identitys?.length > 0))
      return "";

    return `${item?.identitys[0]?.type_identity?.name} ${item?.identitys[0]?.code_identity?.name}-${item?.identitys[0]?.identity}`;

  }


  getContact(item: any) {

    if (!(item?.constacts?.length > 0))
      return "";

    return `${item?.constacts[0]?.contact}`;


  }

  getEmailContact(item: any) {
    if (!(item?.constacts?.length > 0) || !item?.constacts[1]) return '';

    return `${item?.constacts[1]?.contact}`;
  }


  sanitize(url: string) {
    //return url;
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }


  /**
   * Abre modal para visualizar archivos adjuntos o descarga PDFs
   * @param fileData - Objeto file con {url, type_file, base_name} o string (URL)
   * @param modalContent - Template del modal
   */
  async redirectIMG(fileData: any, modalContent?: any): Promise<void> {
    console.log('🔍 DEBUG redirectIMG - fileData recibido:', fileData);
    console.log('🔍 DEBUG redirectIMG - tipo de fileData:', typeof fileData);
    console.log('🔍 DEBUG redirectIMG - fileData.url:', fileData?.url);
    console.log('🔍 DEBUG redirectIMG - fileData.type_file:', fileData?.type_file);
    console.log('🔍 DEBUG redirectIMG - fileData.base_name:', fileData?.base_name);
    
    // Extraer datos del archivo
    let url: string;
    let fileType: string;
    let fileName: string;
    
    if (typeof fileData === 'string') {
      // Compatibilidad: si solo pasan URL
      console.log('⚠️ fileData es string, usando compatibilidad');
      url = fileData;
      fileType = url.toLowerCase().includes('.pdf') ? 'pdf' : 'image';
      fileName = `comprobante_${Date.now()}`;
    } else if (fileData && fileData.url) {
      // Formato correcto: objeto file del backend
      console.log('✅ fileData es objeto con url');
      url = fileData.url;
      fileType = fileData.type_file || 'pdf';
      fileName = fileData.base_name || `comprobante_${Date.now()}`;
    } else {
      console.error('❌ Formato de archivo inválido:', fileData);
      return;
    }

    if (!url) return;

    // Guardar datos para uso posterior
    this.selectedFileUrl = url;
    this.selectedFileName = fileName;
    this.selectedFileExtension = fileType;

    // Detectar si es PDF
    const isPdf = fileType.toLowerCase() === 'pdf';

    if (isPdf) {
      // PDFs: descargar directamente usando el endpoint del backend
      const fileNameWithExt = fileName.endsWith('.pdf') ? fileName : `${fileName}.pdf`;
      
      const blob = await this._user.downloadFile(url, fileType);
      
      if (blob) {
        saveAs(blob, fileNameWithExt);
      } else {
        alertifyjs.error('Error al descargar el archivo');
        window.open(url, '_blank');
      }
    } else {
      // Imágenes: mostrar en modal
      this.selectedFileType = 'image';
      
      if (modalContent) {
        this.modalService.open(modalContent, {
          size: 'xl',
          centered: true,
          backdrop: 'static'
        });
      }
    }
  }

  /**
   * Maneja el error de carga de imagen
   * Si falla, descarga el archivo usando el servicio
   */
  async onImageError(): Promise<void> {
    console.log('Error cargando imagen, descargando archivo...');
    this.closeFileModal();
    
    const fileName = this.selectedFileName || `comprobante_${Date.now()}`;
    const fileExtension = this.selectedFileExtension || 'pdf';
    const fileNameWithExt = fileName.endsWith(`.${fileExtension}`) ? fileName : `${fileName}.${fileExtension}`;
    
    const blob = await this._user.downloadFile(this.selectedFileUrl, fileExtension);
    
    if (blob) {
      saveAs(blob, fileNameWithExt);
    } else {
      alertifyjs.error('Error al descargar el archivo');
      window.open(this.selectedFileUrl, '_blank');
    }
  }

  /**
   * Descarga el archivo actual del modal
   */
  async downloadCurrentFile(): Promise<void> {
    const fileName = this.selectedFileName || `comprobante_${Date.now()}`;
    const fileExtension = this.selectedFileExtension || 'jpg';
    const fileNameWithExt = fileName.endsWith(`.${fileExtension}`) ? fileName : `${fileName}.${fileExtension}`;
    
    const blob = await this._user.downloadFile(this.selectedFileUrl, fileExtension);
    
    if (blob) {
      saveAs(blob, fileNameWithExt);
    } else {
      alertifyjs.error('Error al descargar el archivo');
    }
  }

  /**
   * Cierra el modal de visualización
   */
  closeFileModal(): void {
    this.selectedFileUrl = '';
    this.selectedFileType = '';
    this.selectedFileName = '';
    this.selectedFileExtension = '';
    this.modalService.dismissAll();
  }

findAutopago = (acron: string) => {
  //console.log(acron);
  if(acron==="BA" || acron==="MC" || acron==="BDV" || acron==="AUTO-DETECT") {
    let autopago = this.autopago.find((ele: any) => ele.key===acron);
    if(autopago) {
      return autopago.name;
    } else {
      return null;
    }
  } else {
    return acron
  }
}


getBanks = async () => {
  try {
    const resp = await this.getBanksServices();

    let banks_resp = resp?.res;
    let banks:any = {};


    banks_resp.map((value:any)=>{

      banks[value.bankCode] = value?.name;

    });

    this.banks = banks;


  } catch (error) {
    console.error(error);

  }

}


getBanksServices = async () => {
  return await this._user.getBanks({});
};


setPayment(data:any){
  if (this._auth.hasRbac$.getValue() && !this._auth.hasAnyPermission(['pagos.pagos_registrados.update'])) {
    alertifyjs.error('No tienes permiso para editar pagos');
    return;
  }

  let action = 'Editar'

  Swal.fire({
    title: `¿Deseas ${action} este pago?`,
    text: "¡No podrás revertir esto!",
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    input: "select",
    inputOptions: {
      'Banco Receptor errado': 'Banco Receptor errado',
      'Banco Emisor errado': 'Banco Emisor errado',
      'Número de referencia errado': 'Número de referencia errado',
      'Fecha de Pago errada': 'Fecha de Pago errada',
      'Monto errado': 'Monto errado',
      'Comprobante de pago errado': 'Comprobante de pago errado',
      'Panalidades mal aplicadas': 'Penalidades mal aplicadas'

    },
    inputPlaceholder: 'Selecciona una razón',
    showCancelButton: true,
    confirmButtonText: `Si, ${action}!`,
    showLoaderOnConfirm: true,
    preConfirm: async (reason) => {
      try {
        if (!reason) {
          return Swal.showValidationMessage(`Debe seleccionar una razón de Edición`);
        }
      } catch (error) {
        Swal.showValidationMessage(`Request failed: ${error}`);
      }
    },
    allowOutsideClick: () => !Swal.isLoading()
  }).then((result) => {
    if (result.isConfirmed) {
      data.description_edit = result?.value;
      localStorage.setItem('pe',JSON.stringify(data));
      this.router.navigate([`/console/post`], {});


    }
  });




}




changeSubStatus= async (code:any,code_sub:any) => {
  if (this._auth.hasRbac$.getValue() && !this._auth.hasAnyPermission(['finanzas.verificacion_pagos.activate_review', 'pagos.pagos_registrados.activate_review'])) {
    alertifyjs.error('No tienes permiso para activar/inactivar revisión');
    return;
  }
  this.submit_disabled_changeSubStatus = true;


        let query = {
          code_payment: code,
          code_payment_sub_status:code_sub
        };

         await this._user.payment_sub_statusPost(query);
         this.subStatus[code] = code_sub;
        alertifyjs.success('Cambio exitoso');
        this.submit_disabled_changeSubStatus = false;


}







getpayment_sub_status = async () => {
try {

  const resp = await this.payment_sub_status();
  this.list_payment_sub_status = resp?.resp;

} catch (error) {
  console.error(error);

}




}


payment_sub_status = async () => {
try{
    return this._user.payment_sub_status({});

  } catch (error) {
    console.error(error);


  }
}



paymentRollback = async (payment:any) => {

let action = 'Revertir'

Swal.fire({
  title: `¿Deseas ${action} este pago?`,
  text: "¡No podrás revertir esto!",
  confirmButtonColor: '#3085d6',
  cancelButtonColor: '#d33',
  input: "select",
  inputOptions: {

    'No se encontro en banco': 'No se encontro en banco'

  },
  inputPlaceholder: 'Selecciona una razón',
  showCancelButton: true,
  confirmButtonText: `Si, ${action}!`,
  showLoaderOnConfirm: true,
  preConfirm: async (reason) => {
    try {
      if (!reason) {
        return Swal.showValidationMessage(`Debe seleccionar una razón`);
      }
    } catch (error) {
      Swal.showValidationMessage(`Request failed: ${error}`);
    }
  },
  allowOutsideClick: () => !Swal.isLoading()
}).then((result) => {
  if (result.isConfirmed) {

    this.servicePaymentRollback(payment, result.value);

  }
});
}


servicePaymentRollback = async (payment:any,msg = '') => {

  this.loadcon2 = true;

  try {

    const resp = await this._user.paymentRollback({ code_payment: payment,description:msg });

    const resp_paymentsCredits = await this.listClientPaymentsCredits();
    this.resp_paymentsCredits = resp_paymentsCredits?.res;




    if(resp?.res){
      this.getPerson();

      alertifyjs.success(`Pago devuelto `);

    }
    this.loadcon2 = false;

  } catch (error) {
    alertifyjs.error('Error al devolver pago estatus');

    console.error(error);

  this.loadcon2 = false;
}


  this.loading_person = false;


}

toDateFn(isoString: string): string {
  const [datePart, timePart] = isoString.split('T');
  const [year, month, day] = datePart.split('-');
  return `${day}/${month}/${year}`;
}

validar_penalidad = (fees: any) => {
  return fees.some((row: any) => row?.apply_amount > 0);
}

async loadPayments() {
  console.log('🚀 DEBUG: loadPayments iniciado, person_base_code:', this.person_base_code);
  try {
    this.payments = [];
    const resp = await this._user.listClientPaymentsCreditsConsole({ code_person: this.person_base_code });
    console.log('📡 DEBUG: Respuesta loadPayments:', resp);
    console.log('📡 DEBUG: resp.res en loadPayments:', resp?.res);
    this.payments = resp?.res || []; // Asegúrate de que se maneje el caso donde resp.res sea undefined
    console.log('💾 DEBUG: this.payments asignado:', this.payments);
    this.processPayments(); // Procesa los pagos si es necesario
  } catch (error) {
    console.error('❌ DEBUG: Error al cargar pagos:', error);
  }
}

// 🔄 MÉTODO ESPECÍFICO PARA REFRESCAR LA VISTA (actualiza resp_paymentsCredits)
async refreshPaymentsForView() {
  console.log('🔄 [SOCKET] Refrescando pagos para la vista, person_base_code:', this.person_base_code);
  try {
    const resp_paymentsCredits = await this.listClientPaymentsCredits();
    console.log('📡 [SOCKET] Respuesta refreshPaymentsForView:', resp_paymentsCredits);
    console.log('📡 [SOCKET] resp_paymentsCredits.res:', resp_paymentsCredits?.res);

    // ✅ ACTUALIZAR LA VARIABLE QUE USA LA VISTA
    this.resp_paymentsCredits = resp_paymentsCredits?.res || [];
    console.log('💾 [SOCKET] this.resp_paymentsCredits actualizado:', this.resp_paymentsCredits);

    // 🔄 ACTUALIZAR TAMBIÉN LOS SUB-STATUS
    let temp = resp_paymentsCredits?.res;
    temp?.forEach((element: any) => {
      this.subStatus[element.payment.code] = element?.payment?.payment_sub_status?.code || 'NA';
    });
    console.log('🎯 [SOCKET] subStatus actualizado:', this.subStatus);

  } catch (error) {
    console.error('❌ [SOCKET] Error al refrescar pagos para vista:', error);
  }
}

// 🧪 MÉTODO DE PRUEBA PARA SIMULAR EVENTO DE SOCKET (eliminar en producción)
testSocketEvent() {
  console.log('🧪 [TEST] Simulando evento de socket...');
  const testEvent = {
    type: 'owner-payments-updated',
    action: 'payment_verified',
    paymentCount: 1,
    timestamp: new Date()
  };
  this.handleOwnerPaymentsUpdate(testEvent);
}

processPayments() {
  // Aquí puedes aplicar alguna lógica adicional si necesitas procesar los pagos
  this.payments = this.payments.map(item => {
    // Por ejemplo, podrías agregar un campo o transformación si lo necesitas
    return {
      ...item,
      creator_api_display: this.getCreatorApiDisplay(item)
    };
  });
}

getCreatorApiDisplay(item: any): string {
  const creatorApi = item?.payment?.creator_api;
  if (creatorApi && creatorApi.includes('Caja')) {
    // Acepta formatos: TotalPos, AG, AUTOPAGO (todos con "Caja")
    return creatorApi;
  } else if (['APP', 'CHATBOT', 'CONSOLE'].includes(creatorApi)) {
    return `${creatorApi} / ${item?.payment?.creator?.name} ${item?.payment?.creator?.lastName}`;
  } else {
    return '-'; // Valor por defecto si no se cumple ninguna condición
  }
}


async initializeProductFilter() {
  await this.consultAllProductsInvoices();
  // 💎 Actualizar el término de búsqueda con el filtro por defecto (CREDIT)
  this.updateSearchTermFromSelection();
}

async consultAllProductsInvoices(){
  try {
    this.filterStates.isLoadingProducts = true;
    this.filterStates.hasError = false;

    console.log('🔄 DEBUG: Iniciando carga de productos...');

    let consultProducts = await this._user.getTypesProductsInvoices();

    // Simular un pequeño delay para mostrar el loading (solo en desarrollo)
    await new Promise(resolve => setTimeout(resolve, 300));

    this.productArray = consultProducts.resp;
    this.filteredProductArray = [...this.productArray]; // Inicializar array filtrado
    this.tempSelectedProducts = [...this.selectedProducts]; // Inicializar temp
    this.filterStates.isInitialized = true;

    console.log('✅ DEBUG: Productos cargados:', this.productArray.length);

  } catch (error) {
    console.error('❌ ERROR: Error al cargar productos:', error);
    this.filterStates.hasError = true;
    this.filterStates.errorMessage = 'Error al cargar tipos de productos';
  } finally {
    this.filterStates.isLoadingProducts = false;
  }
}


// === MANEJO PROFESIONAL DEL DROPDOWN ===
async toggleDropdown() {
  if (this.showDropdown) {
    this.closeDropdown();
  } else {
    this.openDropdown();
  }
}

async openDropdown() {
  if (this.filterStates.isLoadingProducts) return;

  // Sincronizar tempSelectedProducts con selectedProducts al abrir
  this.tempSelectedProducts = [...this.selectedProducts];
  console.log('🔄 Abriendo dropdown - tempSelectedProducts:', this.tempSelectedProducts);
  console.log('🔄 Abriendo dropdown - selectedProducts:', this.selectedProducts);

  this.dropdownAnimation.isOpening = true;
  
  // Inicializar array filtrado si no hay búsqueda
  if (!this.productSearchTerm || this.productSearchTerm.trim() === '') {
    this.filteredProductArray = [...this.productArray];
  }

  // Pequeño delay para la animación
  setTimeout(() => {
    this.showDropdown = true;
    this.dropdownAnimation.isOpening = false;
  }, 50);
}

async closeDropdown() {
  this.dropdownAnimation.isClosing = true;

  setTimeout(() => {
    this.showDropdown = false;
    this.dropdownAnimation.isClosing = false;
    // Restaurar selección temporal si no se aplicó
    this.tempSelectedProducts = [...this.selectedProducts];
  }, 150);
}

// Detectar clics fuera del componente para cerrar el dropdown
@HostListener('document:click', ['$event'])
onDocumentClick(event: MouseEvent) {
  if (this.showDropdown) {
    const productSearchContainer = this.elementRef.nativeElement.querySelector('.product-search-input');
    if (productSearchContainer) {
      const clickedInside = productSearchContainer.contains(event.target as Node);
      const clickedOnDropdown = (event.target as HTMLElement).closest('.filter-dropdown');
      
      // Solo cerrar si el clic fue FUERA del contenedor Y fuera del dropdown
      if (!clickedInside && !clickedOnDropdown) {
        this.closeDropdown();
      }
    }
  }
}

// === MANEJO INTELIGENTE DE SELECCIÓN (MÚLTIPLE - mantener checkboxes funcionales) ===
onProductSelectionChange(productCode: string, isChecked: boolean) {
  try {
    if (isChecked) {
      // Agregar producto si no está ya seleccionado
      if (!this.tempSelectedProducts.includes(productCode)) {
        this.tempSelectedProducts.push(productCode);
      }
    } else {
      // Remover producto de la selección
      this.tempSelectedProducts = this.tempSelectedProducts.filter(code => code !== productCode);
    }

    // ✅ CAMBIO: Permitir deseleccionar todos los productos, incluso CREDIT
    // Ya no forzamos CREDIT si no hay productos seleccionados
    // El backend manejará el caso de array vacío con su lógica por defecto

    // Actualizar el término de búsqueda inmediatamente para reflejar la selección
    this.updateSearchTermFromTempSelection();

    console.log('🔄 DEBUG: Productos temporales seleccionados:', this.tempSelectedProducts);
  } catch (error) {
    console.error('❌ ERROR en selección:', error);
  }
}

// Actualizar el término de búsqueda basado en la selección temporal
updateSearchTermFromTempSelection() {
  if (this.tempSelectedProducts.length === 0) {
    this.productSearchTerm = 'Ningún producto seleccionado';
  } else if (this.tempSelectedProducts.length === 1) {
    this.productSearchTerm = this.tempSelectedProducts[0];
  } else if (this.tempSelectedProducts.length === 2) {
    this.productSearchTerm = `${this.tempSelectedProducts[0]} y ${this.tempSelectedProducts[1]}`;
  } else {
    this.productSearchTerm = `${this.tempSelectedProducts.length} productos seleccionados`;
  }
}

// === APLICACIÓN PROFESIONAL DE FILTROS ===
async applyFilters(updateSearchTerm: boolean = true) {
  try {
    this.filterStates.isApplyingFilter = true;
    this.filterStates.isLoadingResults = true;
    this.filterStates.hasError = false;

    // Confirmar selección
    this.selectedProducts = [...this.tempSelectedProducts];

    console.log('✅ DEBUG FILTRO: Aplicando filtros con productos:', this.selectedProducts);

    // Actualizar la barra de búsqueda con el texto de los productos seleccionados (solo si se solicita)
    if (updateSearchTerm) {
      this.updateSearchTermFromSelection();
    }

    // Animación de cierre suave
    await this.closeDropdown();

    // Ejecutar consulta con feedback visual
    console.log('🔎 DEBUG FILTRO: Enviando solicitud al backend con arr_typeProduct:', this.selectedProducts);
    const resp = await this.listClientPaymentsCredits(this.selectedProducts);

    console.log('📡 DEBUG FILTRO: Respuesta del backend recibida:', resp);
    console.log('📡 DEBUG FILTRO: Cantidad de pagos recibidos:', resp?.res?.length || 0);

    // Pequeño delay para UX suave
    await new Promise(resolve => setTimeout(resolve, 400));

    this.resp_paymentsCredits = resp?.res || [];

    console.log('📊 DEBUG FILTRO: Resultados asignados a resp_paymentsCredits:', this.resp_paymentsCredits?.length || 0, 'pagos');
    
    // 🔍 Verificar que los pagos tienen el tipo de producto correcto
    if (this.resp_paymentsCredits && this.resp_paymentsCredits.length > 0) {
      console.log('🔎 DEBUG FILTRO: Verificando tipos de producto en resultados:');
      this.resp_paymentsCredits.forEach((item: any, index: number) => {
        const typeProduct = item?.payment?.typeProduct || 'CREDIT';
        console.log(`  [${index}] Código: ${item?.payment?.code}, Tipo: ${typeProduct}`);
      });
    }

  } catch (error) {
    console.error('❌ ERROR al aplicar filtros:', error);
    this.filterStates.hasError = true;
    this.filterStates.errorMessage = 'Error al aplicar filtros';
  } finally {
    this.filterStates.isApplyingFilter = false;
    this.filterStates.isLoadingResults = false;
  }
}

// === FUNCIONES DE UTILIDAD MEJORADAS ===
isProductSelected(productCode: string): boolean {
  return this.tempSelectedProducts.includes(productCode);
}

// 💎 BÚSQUEDA DE PRODUCTOS - Propiedades y Métodos
productSearchTerm: string = 'CREDIT'; // Inicializar con CREDIT por defecto
filteredProductArray: any[] = [];

// Filtrar productos por búsqueda
filterProductsSearch() {
  if (!this.productArray) {
    this.filteredProductArray = [];
    return;
  }

  if (!this.productSearchTerm || this.productSearchTerm.trim() === '') {
    this.filteredProductArray = [...this.productArray];
    return;
  }

  const term = this.productSearchTerm.toLowerCase().trim();
  this.filteredProductArray = this.productArray.filter((product: any) => {
    return (
      product?.params?.name?.toLowerCase().includes(term) ||
      product?.params?.code?.toLowerCase().includes(term) ||
      (product?.params?.dinamic_code && 
       product.params.dinamic_code.some((code: string) => code.toLowerCase().includes(term)))
    );
  });

  console.log('🔍 Productos filtrados:', this.filteredProductArray.length);
}

// Limpiar búsqueda de productos y volver a CREDIT por defecto
async clearProductSearch() {
  // Limpiar el término de búsqueda visual y volver a CREDIT
  this.productSearchTerm = 'CREDIT';
  this.filteredProductArray = [...this.productArray];
  
  // Volver a CREDIT por defecto
  this.tempSelectedProducts = ['CREDIT'];
  this.selectedProducts = ['CREDIT'];
  
  // Aplicar filtros para reflejar el cambio
  await this.applyFilters();
}

// Actualizar el término de búsqueda con los productos seleccionados
updateSearchTermFromSelection() {
  if (this.selectedProducts.length === 0) {
    this.productSearchTerm = '';
  } else if (this.selectedProducts.length === 1) {
    // Un solo producto: mostrar su código
    this.productSearchTerm = this.selectedProducts[0];
  } else if (this.selectedProducts.length === 2) {
    // Dos productos: mostrar ambos códigos separados por "y"
    this.productSearchTerm = `${this.selectedProducts[0]} y ${this.selectedProducts[1]}`;
  } else {
    // Más de 2 productos: mostrar resumen
    this.productSearchTerm = `${this.selectedProducts.length} productos seleccionados`;
  }
  
  console.log('🔍 Término de búsqueda actualizado:', this.productSearchTerm);
}

getSelectedProductsText(): string {
  const count = this.selectedProducts.length;

  if (count === 0) {
    return 'Seleccionar productos...';
  }
  if (count === 1) {
    return this.selectedProducts[0];
  }
  if (count === 2) {
    return `${this.selectedProducts[0]} y ${this.selectedProducts[1]}`;
  }
  return `${count} productos seleccionados`;
}

async clearAllFilters() {
  this.tempSelectedProducts = ['CREDIT'];
  this.selectedProducts = ['CREDIT'];

  console.log('🧹 DEBUG: Filtros limpiados, volviendo a CREDIT');

  try {
    this.filterStates.isLoadingResults = true;
    const resp = await this.listClientPaymentsCredits(this.selectedProducts);
    this.resp_paymentsCredits = resp?.res || [];
  } catch (error) {
    console.error('❌ ERROR al limpiar filtros:', error);
  } finally {
    this.filterStates.isLoadingResults = false;
  }
}

// === FUNCIÓN DE RETRY PARA ERRORES ===
async retryOperation() {
  this.filterStates.hasError = false;
  this.filterStates.errorMessage = '';

  if (!this.filterStates.isInitialized) {
    await this.consultAllProductsInvoices();
  } else {
    await this.applyFilters();
  }
}

// === FUNCIONES DE OPTIMIZACIÓN ===
trackByProductCode(index: number, item: any): string {
  return item?.params?.code || index;
}

// 🔄 ASYNC PAYMENT HISTORY MODAL METHODS
openAsyncHistoryModal(payment: any) {
  this.selectedAsyncPayment = payment;

  // Método más robusto para abrir modal
  setTimeout(() => {
    const modalElement = document.getElementById('asyncHistoryModal');
    if (modalElement) {
      // Intentar con Bootstrap 5 primero
      try {
        if ((window as any).bootstrap && (window as any).bootstrap.Modal) {
          const modal = new (window as any).bootstrap.Modal(modalElement);
          modal.show();
          return;
        }
      } catch (error) {
        // Bootstrap 5 no disponible
      }

      // Intentar con jQuery
      try {
        if ((window as any).$ && (window as any).$('#asyncHistoryModal').modal) {
          (window as any).$('#asyncHistoryModal').modal('show');
          return;
        }
      } catch (error) {
        // jQuery no disponible
      }

      // Fallback: Mostrar modal manualmente
      try {
        modalElement.style.display = 'block';
        modalElement.classList.add('show');
        modalElement.setAttribute('aria-hidden', 'false');

        // Agregar backdrop
        const backdrop = document.createElement('div');
        backdrop.className = 'modal-backdrop fade show';
        backdrop.id = 'asyncModalBackdrop';
        document.body.appendChild(backdrop);

        // Agregar clase al body
        document.body.classList.add('modal-open');

        // Agregar event listener para cerrar
        this.addModalCloseListeners();

      } catch (manualError) {
        // Último recurso: alert con información
        const historyInfo = payment.async?.attempt_history?.map((attempt: any, index: number) =>
          `Intento ${index + 1}: ${attempt.status} - ${this.formatAsyncDate(attempt.started_at)}`
        ).join('\n') || 'Sin historial disponible';

        alert(`Historial Async - Pago: ${payment.code}\nStatus: ${payment.async?.status}\nIntentos: ${payment.async?.attempt || 0}/${payment.async?.max_attempts || 0}\n\n${historyInfo}`);
      }
    }
  }, 100);
}

// 🔒 HELPER METHOD TO ADD MODAL CLOSE LISTENERS
addModalCloseListeners() {
  // Cerrar con botón X o botón Cerrar
  const closeButtons = document.querySelectorAll('#asyncHistoryModal [data-bs-dismiss="modal"]');
  closeButtons.forEach(button => {
    button.addEventListener('click', () => this.closeAsyncModal());
  });

  // Cerrar con backdrop
  const backdrop = document.getElementById('asyncModalBackdrop');
  if (backdrop) {
    backdrop.addEventListener('click', () => this.closeAsyncModal());
  }

  // Cerrar con ESC
  const escListener = (event: KeyboardEvent) => {
    if (event.key === 'Escape') {
      this.closeAsyncModal();
      document.removeEventListener('keydown', escListener);
    }
  };
  document.addEventListener('keydown', escListener);
}

// 🚪 HELPER METHOD TO CLOSE MODAL
closeAsyncModal() {
  const modalElement = document.getElementById('asyncHistoryModal');
  const backdrop = document.getElementById('asyncModalBackdrop');

  if (modalElement) {
    modalElement.style.display = 'none';
    modalElement.classList.remove('show');
    modalElement.setAttribute('aria-hidden', 'true');
  }

  if (backdrop) {
    backdrop.remove();
  }

  document.body.classList.remove('modal-open');
}

// 🕒 HELPER METHOD FOR SAFE DATE FORMATTING
formatDate(dateValue: any, format: 'datetime' | 'date' = 'datetime'): string {
  if (!dateValue) return '-';

  try {
    let date: Date | null = null;

    // Si es un string, intentar parsearlo
    if (typeof dateValue === 'string') {
      date = new Date(dateValue);
    }
    // Si es un objeto Date válido
    else if (dateValue instanceof Date) {
      date = dateValue;
    }
    // Si es un timestamp
    else if (typeof dateValue === 'number') {
      date = new Date(dateValue);
    }
    // Si es un objeto con propiedades de fecha
    else if (typeof dateValue === 'object' && dateValue !== null) {
      // Intentar diferentes propiedades comunes
      const dateStr = dateValue.date || dateValue.value || dateValue.toString();
      if (dateStr) {
        date = new Date(dateStr);
      }
    }

    // Verificar si la fecha es válida
    if (date && !isNaN(date.getTime())) {
      if (format === 'date') {
        return date.toLocaleDateString('es-ES', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
      } else {
        return date.toLocaleString('es-ES', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true
        });
      }
    }

    return 'Fecha inválida';
  } catch (error) {
    console.warn('⚠️ Error formateando fecha:', error);
    return 'Error en fecha';
  }
}

// 🕒 HELPER METHOD FOR ASYNC DATE FORMATTING (uses the general formatDate)
formatAsyncDate(dateValue: any): string {
  return this.formatDate(dateValue, 'datetime');
}

// 🚀 CONFIGURAR LISTENERS DE SOCKET PARA PAGOS ASÍNCRONOS
private setupPaymentSocketListeners(): void {
  // 🚫 EVITAR CONFIGURACIÓN MÚLTIPLE
  if (this.socketsConfigured) {
    console.log('⚠️ [PAYMENT-SOCKET] Listeners ya configurados, omitiendo...');
    return;
  }

  // 🧹 LIMPIAR SUSCRIPCIONES ANTERIORES PARA EVITAR DUPLICADOS
  this.cleanupSocketSubscriptions();

  // Solo configurar si tenemos un person válido
  if (this.person?.person?._id) {
    console.log('🎧 [PAYMENT-SOCKET] Configurando listeners para person:', this.person.person._id);

    // Escuchar eventos específicos del owner (person)
    this.paymentSocketService.listenToOwnerUpdates(this.person.person._id);

    // 📊 SUSCRIBIRSE SOLO A EVENTOS ESPECÍFICOS DEL OWNER (evita duplicidades)
    this.ownerUpdatesSubscription = this.paymentSocketService.specificOwnerUpdates.subscribe(ownerUpdate => {
      if (ownerUpdate && ownerUpdate.ownerId === this.person.person._id) {
        console.log('📊 [SOCKET] Evento específico del owner recibido - ACTUALIZANDO:', ownerUpdate);
        this.handleOwnerPaymentsUpdate(ownerUpdate);
      }
    });

    // 🏁 MARCAR COMO CONFIGURADOS
    this.socketsConfigured = true;
    console.log('✅ [PAYMENT-SOCKET] Listeners configurados exitosamente');
  } else {
    console.log('⚠️ [PAYMENT-SOCKET] No se puede configurar listeners: person no válido');
  }
}

// 🧹 LIMPIAR SUSCRIPCIONES DE SOCKET
private cleanupSocketSubscriptions(): void {
  if (this.ownerUpdatesSubscription) {
    this.ownerUpdatesSubscription.unsubscribe();
    this.ownerUpdatesSubscription = null;
  }

  // 🏁 RESETEAR BANDERAS PARA PERMITIR RECONFIGURACIÓN SI ES NECESARIO
  this.socketsConfigured = false;
  this.isInitialLoad = true;
}

// 📊 MANEJAR ACTUALIZACIÓN DE PAGOS DEL OWNER
private handleOwnerPaymentsUpdate(ownerUpdate: any): void {
  console.log('📊 [SOCKET] ===== ACTUALIZACIÓN DEL OWNER =====');
  console.log('📊 [SOCKET] Datos completos del evento:', JSON.stringify(ownerUpdate, null, 2));
  console.log('📊 [SOCKET] isInitialLoad:', this.isInitialLoad);
  console.log('📊 [SOCKET] socketsConfigured:', this.socketsConfigured);
  console.log('📊 [SOCKET] ownerUpdate.action:', ownerUpdate.action);
  console.log('📊 [SOCKET] ownerUpdate.type:', ownerUpdate.type);

  // 🚫 EVITAR ALERTAS DURANTE LA CARGA INICIAL
  if (this.isInitialLoad) {
    console.log('🚫 [SOCKET] Evento ignorado durante carga inicial');

    // 🔄 PERO AÚN REFRESCAR LA VISTA SILENCIOSAMENTE
    this.refreshPaymentsForView().then(() => {
      console.log('📊 [SOCKET] ===== OWNER PAGOS RECARGADOS SILENCIOSAMENTE =====');
      this.cdr.detectChanges();
    });
    return;
  }

  // 🔔 MOSTRAR ALERTA PARA CUALQUIER EVENTO DE PAGO (por ahora para debug)
  console.log('🔔 [SOCKET] Procesando evento después de carga inicial');

  // Determinar si es un evento que merece alerta
  const shouldShowAlert = ownerUpdate.action === 'payment_verified' ||
                         ownerUpdate.action === 'payment_failed' ||
                         ownerUpdate.type === 'owner-payments-updated';

  if (shouldShowAlert) {
    console.log('🔔 [SOCKET] Mostrando alerta para evento:', ownerUpdate.action || ownerUpdate.type);

    let statusText = 'actualizado';
    let icon: 'success' | 'error' | 'info' = 'info';

    if (ownerUpdate.action === 'payment_verified') {
      statusText = 'verificado exitosamente';
      icon = 'success';
    } else if (ownerUpdate.action === 'payment_failed') {
      statusText = 'falló en la verificación';
      icon = 'error';
    }

    Swal.fire({
      title: '🔔 Pago Actualizado',
      text: `Un pago ha sido ${statusText}. Actualizando lista...`,
      icon: icon,
      timer: 3000,
      timerProgressBar: true,
      position: 'top-end',
      toast: true,
      showConfirmButton: false
    });
  } else {
    console.log('🔕 [SOCKET] Evento sin alerta, action:', ownerUpdate.action, 'type:', ownerUpdate.type);
  }

  // 🔄 RECARGAR LOS PAGOS PARA REFLEJAR LOS CAMBIOS (usando la variable correcta de la vista)
  this.refreshPaymentsForView().then(() => {
    console.log('📊 [SOCKET] ===== OWNER PAGOS RECARGADOS EN VISTA =====');
    // 🔄 FORZAR DETECCIÓN DE CAMBIOS EN ANGULAR
    this.cdr.detectChanges();
  });
}

// 🧹 LIMPIAR LISTENERS AL DESTRUIR COMPONENTE
ngOnDestroy(): void {
  console.log('🧹 [PAYMENT-SOCKET] Destruyendo componente y limpiando listeners');

  // Limpiar suscripciones locales
  this.cleanupSocketSubscriptions();

  // Limpiar listeners del servicio si hay un person válido
  if (this.person?.person?._id) {
    console.log('🧹 [PAYMENT-SOCKET] Limpiando listeners para person:', this.person.person._id);
    this.paymentSocketService.cleanupOwnerListeners(this.person.person._id);
  }

  // 🏁 RESETEAR BANDERAS
  this.socketsConfigured = false;
  this.isInitialLoad = true; // Resetear para la próxima carga
}

// 🏥 MÉTODOS PARA REPORTE DE SEGUROS
selectedInsuranceReportPayment: any = null;

/**
 * 🔄 Reportar o reintentar reporte de pago a aseguradora
 */
// Abre el modal compartido de reporte a la aseguradora (mismo flujo/UX que la
// Consola de Seguros: dry-run, comparación, JSON y confirmación). Mapeamos el
// pago de esta vista al shape que espera el componente; el backend deriva el
// resto desde la BD a partir del código del pago.
openInsuranceReport(item: any) {
  const pay = item?.payment || {};
  const ir = pay?.params?.insurance_report || null;
  const per = this.person?.person || pay?.owner || {};
  this.insReportPayment = {
    code: pay.code,
    person: {
      name: per?.name ? `${per.name} ${per.lastName || ''}`.trim() : (per?.fullName || ''),
      cedula: per?.identity || per?.cedula || null,
      code: per?.code || null,
      gender: per?.gender || null,
      photo_url: per?.file_selfie?.url || per?.photo_url || null
    },
    amount: pay.amount,
    rate: pay.rate,
    bank: pay.bank,
    reference: pay.reference || pay.paymentMethodId || null,
    date: pay.date,
    typeProduct: pay.typeProduct,
    policy_code: ir?.policy_code || null,
    insurance_report: ir
  };
  this.insReportOpen = true;
}

// El modal compartido emitió (reported): refrescamos los datos de la persona.
onInsuranceReported() {
  this.getPerson();
}

/**
 * 🏥 Abrir modal de historial de reporte de seguros
 */
openInsuranceReportHistoryModal(payment: any) {
  this.selectedInsuranceReportPayment = payment;

  // Intentar múltiples métodos para abrir el modal
  try {
    // Método 1: Bootstrap 5 API
    const modalElement = document.getElementById('insuranceReportHistoryModal');
    if (modalElement) {
      // Verificar si Bootstrap está disponible
      if (typeof (window as any).bootstrap !== 'undefined') {
        const modal = new (window as any).bootstrap.Modal(modalElement);
        modal.show();
        return;
      }

      // Método 2: jQuery Bootstrap (fallback)
      if (typeof (window as any).$ !== 'undefined') {
        (window as any).$('#insuranceReportHistoryModal').modal('show');
        return;
      }

      // Método 3: Atributos HTML directos (fallback)
      modalElement.setAttribute('style', 'display: block');
      modalElement.classList.add('show');
      document.body.classList.add('modal-open');

      // Crear backdrop
      const backdrop = document.createElement('div');
      backdrop.className = 'modal-backdrop fade show';
      backdrop.id = 'insuranceReportModalBackdrop';
      document.body.appendChild(backdrop);
    }
  } catch (error) {
    // Silenciar errores en producción
  }
}

/**
 * 🚪 Cerrar modal de historial de reporte de seguros
 */
closeInsuranceReportHistoryModal() {
  try {
    const modalElement = document.getElementById('insuranceReportHistoryModal');
    const backdrop = document.getElementById('insuranceReportModalBackdrop');

    if (modalElement) {
      modalElement.setAttribute('style', 'display: none');
      modalElement.classList.remove('show');
      document.body.classList.remove('modal-open');
    }

    if (backdrop) {
      backdrop.remove();
    }
  } catch (error) {
    // Silenciar errores en producción
  }
}

}
